export const PLANS = [
  { value: 'demo', label: 'Demo', color: 'bg-slate-600' },
  { value: 'pro', label: 'Pro', color: 'bg-blue-600' },
  { value: 'enterprise', label: 'Enterprise', color: 'bg-amber-600' }
];

export const BUSINESS_TYPES = [
  // Giros Base
  { value: 'educacion', label: 'Educación' },
  { value: 'salud', label: 'Salud (Clínicas y Consultorios)' },
  { value: 'farmacia', label: 'Farmacia' },
  { value: 'taller_mecanico', label: 'Taller Mecánico' },
  { value: 'bienes_raices', label: 'Bienes Raíces' },
  { value: 'despacho', label: 'Despacho (Contable, Jurídico, Admin)' },
  { value: 'comercio_retail', label: 'Comercio Minorista / Retail' },
  { value: 'tienda_conveniencia', label: 'Tienda de Conveniencia / Abarrotes' },
  { value: 'distribuidora', label: 'Distribuidora y Mayorista' },
  
  // Giros Operativos
  { value: 'logistica', label: 'Logística y Reparto' },
  { value: 'construccion', label: 'Construcción' },
  { value: 'restaurante_alimentos', label: 'Restaurante y Alimentos' },
  
  // Giros Especializados
  { value: 'produccion_alimentos', label: 'Prod. y Logística Alimentos/Bebidas' },
  { value: 'manufactura', label: 'Producción / Manufactura Ligera' },
  
  // Otros
  { value: 'tecnologia_ti', label: 'Tecnología y Servicios TI' },
  { value: 'servicios_empresariales', label: 'Servicios Empresariales' },
  { value: 'hotel_hospedaje', label: 'Hotel y Hospedaje' },
  { value: 'otro', label: 'Otro' }
];
